import { copyColorData } from "./color";
import { PropController } from "../prop-controllers/base";
const StyleControlType = "makeswift::controls::style";
const StyleControlProperty = {
  Width: "makeswift::controls::style::property::width",
  Margin: "makeswift::controls::style::property::margin",
  Padding: "makeswift::controls::style::property::padding",
  Border: "makeswift::controls::style::property::border",
  BorderRadius: "makeswift::controls::style::property::border-radius",
  TextStyle: "makeswift::controls::style::property::text-style"
};
const StyleControlDefaultProperties = [
  StyleControlProperty.Width,
  StyleControlProperty.Margin
];
const AllStyleControlProperties = [
  StyleControlProperty.Width,
  StyleControlProperty.Margin,
  StyleControlProperty.Padding,
  StyleControlProperty.Border,
  StyleControlProperty.BorderRadius,
  StyleControlProperty.TextStyle
];
function Style(params) {
  return {
    type: StyleControlType,
    config: { properties: params?.properties ?? StyleControlDefaultProperties }
  };
}
Style.Default = StyleControlDefaultProperties;
Style.All = AllStyleControlProperties;
Style.Width = StyleControlProperty.Width;
Style.Margin = StyleControlProperty.Margin;
Style.Padding = StyleControlProperty.Padding;
Style.Border = StyleControlProperty.Border;
Style.BorderRadius = StyleControlProperty.BorderRadius;
Style.TextStyle = StyleControlProperty.TextStyle;
const StyleControlMessageType = {
  CHANGE_BOX_MODEL: "makeswift::controls::style::message::change-box-model"
};
class StyleControl extends PropController {
  constructor(send) {
    super(send);
  }
  changeBoxModel(boxModel) {
    this.send({ type: StyleControlMessageType.CHANGE_BOX_MODEL, payload: { boxModel } });
  }
  recv() {
  }
}
function getStyleSwatchIds(data) {
  const swatchIds = [];
  data?.border?.forEach(({ value }) => {
    if (value.borderTop?.color?.swatchId)
      swatchIds.push(value.borderTop.color.swatchId);
    if (value.borderRight?.color?.swatchId)
      swatchIds.push(value.borderRight.color.swatchId);
    if (value.borderBottom?.color?.swatchId)
      swatchIds.push(value.borderBottom.color.swatchId);
    if (value.borderLeft?.color?.swatchId)
      swatchIds.push(value.borderLeft.color.swatchId);
  });
  return swatchIds;
}
function copyStyleData(value, context) {
  if (value == null)
    return value;
  function copyResponsiveBorder(responsiveBorder) {
    if (responsiveBorder == null)
      return void 0;
    return responsiveBorder.map((deviceBorder) => ({
      ...deviceBorder,
      value: copyBorder(deviceBorder.value)
    }));
  }
  function copyBorder(border) {
    function copyBorderSide(side) {
      if (side == null)
        return null;
      if (side.color == null)
        return side;
      return {
        ...side,
        color: copyColorData(side.color, context)
      };
    }
    return {
      borderTop: copyBorderSide(border.borderTop),
      borderBottom: copyBorderSide(border.borderBottom),
      borderRight: copyBorderSide(border.borderRight),
      borderLeft: copyBorderSide(border.borderLeft)
    };
  }
  return { ...value, border: copyResponsiveBorder(value.border) };
}
export {
  Style,
  StyleControl,
  StyleControlMessageType,
  StyleControlProperty,
  StyleControlType,
  copyStyleData,
  getStyleSwatchIds
};
//# sourceMappingURL=style.js.map